const getters = {
    token: (state) => state.user.token,
    departmentName: (state) => state.user.departmentName,
    research: (state) => ({
        comInfo: state.research.comInfo,
        reportStepId: state.research.reportStepId,
        declareStepStatus: state.research.declareStepStatus,
        nowStepStatus: state.research.nowStepStatus,
        childStepStatus: state.research.childStepStatus
    }),
    declare: (state) => ({
        comInfo: state.declare.comInfo,
        reportStepId: state.declare.reportStepId,
        declareStepStatus: state.declare.declareStepStatus,
        nowStepStatus: state.declare.nowStepStatus,
        childStepStatus: state.declare.childStepStatus
    }),
    task: (state) => ({
        comInfo: state.task.comInfo,
        reportStepId: state.task.reportStepId,
        declareStepStatus: state.task.declareStepStatus,
        nowStepStatus: state.task.nowStepStatus,
        reportBookFileId: state.task.reportBookFileId,
        childStepStatus: state.task.childStepStatus
    }),
    annual: (state) => ({
        comInfo: state.annual.comInfo,
        reportStepId: state.annual.reportStepId,
        annualStepStatus: state.annual.annualStepStatus,
        nowStepStatus: state.annual.nowStepStatus,
        childStepStatus: state.annual.childStepStatus
    })
};
export default getters;
